import {
  Coord,
  Movement,
} from '../models/manager-content-vehicle-history-drawer.model';
import { COLOR_HISTORY } from '../static/color-elements.static';

interface PopupMovement {
  start_date: string;
  end_date: string;
  avg_speed_kmh: number;
  distance_km: number;
  start_coord: Coord;
  reference_start: string;
  end_coord: Coord;
  reference_end: string;
}

let popupIdCounter = 0;

export function createPopupMovement(
  data: PopupMovement,
  movementIndex: number = 1
) {
  popupIdCounter++;
  const id = `popup-movement-${popupIdCounter}`;
  const urlGoogleMapsStart = `https://www.google.com/maps/search/?api=1&query=${data.start_coord.latitude},${data.start_coord.longitude}`;
  const urlGoogleMapsEnd = `https://www.google.com/maps/search/?api=1&query=${data.end_coord.latitude},${data.end_coord.longitude}`;

  const startLongitude = data.start_coord.longitude
    ? `${data.start_coord.longitude.toFixed(6)}°`
    : '0°';
  const startLatitude = data.start_coord.latitude
    ? `${data.start_coord.latitude.toFixed(6)}°`
    : '0°';
  const endLongitude = data.end_coord.longitude
    ? `${data.end_coord.longitude.toFixed(6)}°`
    : '0°';
  const endLatitude = data.end_coord.latitude
    ? `${data.end_coord.latitude.toFixed(6)}°`
    : '0°';

  const avgSpeed = data.avg_speed_kmh ? `${data.avg_speed_kmh} km/h` : '0 km/h';
  const distance = data.distance_km ? `${data.distance_km} km` : '0 km';

  const startDate = data.start_date
    ? new Date(data.start_date)
        .toLocaleString('es-ES', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        })
        .replace(',', '')
    : '00/00/0000 00:00:00';

  const endDate = data.end_date
    ? new Date(data.end_date)
        .toLocaleString('es-ES', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        })
        .replace(',', '')
    : '00/00/0000 00:00:00';

  const ids = {
    startPos: `${id}-startPos-movement`,
    endPos: `${id}-endPos-movement`,
    startReference: `${id}-startReference-movement`,
    endReference: `${id}-endReference-movement`,
    avgSpeed: `${id}-avgSpeed-movement`,
    distance: `${id}-distance-movement`,
    startDate: `${id}-startDate-movement`,
    endDate: `${id}-endDate-movement`,
  };

  // Formatear el número de movimiento con ceros a la izquierda (5 dígitos)
  const movementNumber = movementIndex.toString().padStart(5, '0');

  // Header tipo chip
  const header = `
    <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px;">
      <div style="flex:1; display:flex; justify-content:center;">
        <span style="background:#2563eb11; color:#2563eb; font-weight:600; border-radius:12px; padding:4px 18px; font-size:13px; letter-spacing:1px; box-shadow:0 1px 4px #0001;">MOVIMIENTO ${movementNumber}</span>
      </div>
    </div>
  `;

  const popup = `
    ${header}
    <div id="${id}" style="font-family: 'Inter', Arial, sans-serif; font-size: 13px; color: #222;">
      
      <div style="margin-bottom: 4px; display: flex; align-items: center; gap: 4px;">
        <span style="font-weight: 600; max-width: 100px; min-width: 100px; width: 100%">Posición inicio:</span>
        <span id="${
          ids.startPos
        }-content" style="min-width: 170px; color: #1976d2; text-decoration: underline; cursor: pointer;" onclick="window.open('${urlGoogleMapsStart}', '_blank')">${startLatitude}, ${startLongitude}</span>
        <span id="${
          ids.startPos
        }" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
      </div>
      
      <div style="margin-bottom: 4px; display: flex; align-items: center; gap: 4px;">
        <span style="font-weight: 600; max-width: 100px; min-width: 100px; width: 100%">Referencia inicio:</span>
        <span style="min-width: 170px; max-width: 170px;" id="${
          ids.startReference
        }-content">
          ${
            data.reference_start
              ? data.reference_start
              : 'Buscando dirección ...'
          }
        </span>
        <span id="${
          ids.startReference
        }" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
      </div>
      
      <div style="margin-bottom: 4px; display: flex; align-items: center; gap: 4px;">
        <span style="font-weight: 600; max-width: 100px; min-width: 100px; width: 100%">Posición fin:</span>
        <span id="${
          ids.endPos
        }-content" style="min-width: 170px; color: #1976d2; text-decoration: underline; cursor: pointer;" onclick="window.open('${urlGoogleMapsEnd}', '_blank')">${endLatitude}, ${endLongitude}</span>
        <span id="${
          ids.endPos
        }" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
      </div>
      
      <div style="margin-bottom: 4px; display: flex; align-items: center; gap: 4px;">
        <span style="font-weight: 600; max-width: 100px; min-width: 100px; width: 100%">Referencia fin:</span>
        <span style="min-width: 170px; max-width: 170px;" id="${
          ids.endReference
        }-content">
          ${data.reference_end ? data.reference_end : 'Buscando dirección ...'}
        </span>
        <span id="${
          ids.endReference
        }" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
      </div>

      <div style="margin-bottom: 4px; display: flex; align-items: center; gap: 4px;">
        <span style="font-weight: 600; max-width: 100px; min-width: 100px; width: 100%">Fecha de inicio:</span>
        <span style="min-width: 170px;" id="${
          ids.startDate
        }-content">${startDate}</span>
        <span id="${
          ids.startDate
        }" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
      </div>
      
      <div style="margin-bottom: 12px; display: flex; align-items: center; gap: 4px;">
        <span style="font-weight: 600; max-width: 100px; min-width: 100px; width: 100%">Fecha de fin:</span>
        <span style="min-width: 170px;" id="${
          ids.endDate
        }-content">${endDate}</span>
        <span id="${
          ids.endDate
        }" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
      </div>
      
      <div style="margin-bottom: 4px; display: flex; align-items: center; gap: 4px;">
        <span style="font-weight: 600; max-width: 100px; min-width: 100px; width: 100%">Velocidad promedio:</span>
        <span style="min-width: 170px;" id="${
          ids.avgSpeed
        }-content">${avgSpeed}</span>
        <span id="${
          ids.avgSpeed
        }" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
      </div>
      
      <div style="margin-bottom: 4px; display: flex; align-items: center; gap: 4px;">
        <span style="font-weight: 600; max-width: 100px; min-width: 100px; width: 100%">Distancia:</span>
        <span style="min-width: 170px;" id="${
          ids.distance
        }-content">${distance}</span>
        <span id="${
          ids.distance
        }" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
      </div>
    </div>
  `;

  // Devuelve el HTML y los valores a copiar para el listener externo
  return {
    html: popup,
    ids,
    values: {
      startPos: `${data.start_coord.latitude},${data.start_coord.longitude}`,
      endPos: `${data.end_coord.latitude},${data.end_coord.longitude}`,
      startReference: data.reference_start,
      endReference: data.reference_end,
      avgSpeed: avgSpeed,
      distance: distance,
      startDate: startDate ?? '',
      endDate: endDate ?? '',
    },
  };
}

export function adaptMovementToPopupMovement(
  movement: Movement
): PopupMovement {
  return {
    start_date: movement.start,
    end_date: movement.end,
    avg_speed_kmh: movement.avg_speed_kmh,
    distance_km: movement.distance_km,
    start_coord: movement.coords[0],
    reference_start: movement.reference_start ?? '',
    end_coord: movement.coords[movement.coords.length - 1],
    reference_end: movement.reference_end ?? '',
  };
}
